import { lazy } from "react";

export const InactiveSubscriptionAsync = lazy(() => import("./InactiveSubscription"));
